import React from "react";
import { FaLink } from "react-icons/fa";
import "./upload.css";

function UploadFile(props) {
  let {
    title,
    onChange,
    value,
    accept,
    children,
    id,
    color,
    customStyles,
    imgSize,
  } = props;
  return (
    <div className="flex justify-start mt-7 ">
      <div className="w-96">
        <label
          htmlFor="formFile"
          className={`form-label text-sm mb-2 font-medium ${
            color ? `text-[${color}]` : "text-[#A7A7A7]"
          } flex ${customStyles}`}
        >
          {title}
          <span>{children}</span>
        </label>
        <label className="relative flex flex-row items-center mt-2">
          <FaLink className="text-[#737373] absolute left-3" />
          <span className="text-[#737373] absolute left-10">{`Choose File (${imgSize})`}</span>
          <input
            disabled={props.disabled}
            type="file"
            className={`h-12 ${
              id === "premiumFile" ? "premiumFile" : "custom-file-input"
            } appearance-none w-full border-[#A7A7A7] rounded-md border px-4 z-0 shadow outline-none`}
            accept={accept ? accept : "image/*"}
            name="uploadfile"
            id="img"
            onChange={onChange}
          />
        </label>
        <p className="mt-2 text-xs">{value}</p>
      </div>
    </div>
  );
}

export default UploadFile;
